import { ClearableTextField } from '@app/components/form/ClearableTextField';
import { ComponentProps } from 'react';
import { defineMessage, useIntl } from 'react-intl';

export const campaignFieldMessage = defineMessage({
  id: 'audit.props.campaign',
  defaultMessage: 'Campaña',
});

type CampaignFieldProps = Omit<ComponentProps<typeof ClearableTextField>, 'name' | 'label'> & {
  name?: string;
  label?: string;
};

/**
 * Shared Formik text field for filtering by campaign.
 */
export function CampaignField({
  name = 'campaign',
  submitOnClear = true,
  label,
  ...props
}: CampaignFieldProps) {
  const { $t } = useIntl();

  return (
    <ClearableTextField
      name={name}
      submitOnClear={submitOnClear}
      label={label ?? $t(campaignFieldMessage)}
      {...props}
    />
  );
}
